import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList as fetchChargeList } from '@/api/PMS/chargeManagement/chargingParameterSetting/chargingStandardSetting/chargingStandardSetting';
export default {
  props: {
    isAddContract: Boolean,
    contractClauseList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    contractBondList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    houseList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    state: {
      type: String,
      default: 'add'
    },
    baseInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isGeneratingBills: Boolean,
    showDialog: Boolean
  },
  data: function data() {
    return {
      rules: {
        upIdList: [{
          required: true,
          message: '请选择房间',
          trigger: 'change'
        }]
      },
      couldNext: true,
      clauseList: [{}],
      bindList: [],
      bondList: [],
      houseOption: [],
      undertakerOption: [{
        value: 2,
        name: '租户'
      }, {
        value: 1,
        name: '业主'
      }],
      projectOption: [],
      chargeOption: []
    };
  },
  watch: {
    contractClauseList: {
      handler: function handler(val, oldval) {
        this.clauseList = val;
      },
      deep: true,
      immediate: true
    },
    contractBondList: {
      handler: function handler(val, oldval) {
        this.bondList = val;
      },
      deep: true
    },
    clauseList: {
      handler: function handler(val, oldval) {
        this.$emit('generatingBills', {
          clauseList: this.clauseList,
          bondList: this.bondList
        });
      },
      deep: true
    },
    bondList: {
      handler: function handler(val, oldval) {
        this.$emit('generatingBills', {
          clauseList: this.clauseList,
          bondList: this.bondList
        });
      },
      deep: true
    },
    houseList: {
      handler: function handler(val, oldval) {
        var _this = this;

        setTimeout(function () {
          _this.handleHouseOption(val);
        }, 100);
      },
      deep: true,
      immediate: true
    }
  },
  created: function created() {
    this.init();
    this.loadChargeOption();
  },
  methods: {
    init: function init() {
      if (this.isAddContract) {
        this.clauseList = [{}];
        this.bondList = [];
      }
    },
    handleChargeStandard: function handleChargeStandard(val, index) {
      var standItem = this.chargeOption.find(function (item) {
        return item.chargeStandardId === val;
      });

      if (standItem) {
        this.clauseList[index].chargeMath = standItem.chargeMath;
        this.clauseList[index].chargePrice = standItem.standardPrice;
        this.clauseList[index].priceUnit = standItem.priceUnit;
        this.clauseList[index].fixedAmount = standItem.fixedAmount;
      }
    },
    handleBondChargeStandard: function handleBondChargeStandard(val, index) {
      var standItem = this.chargeOption.find(function (item) {
        return item.chargeStandardId === val;
      });

      if (standItem) {
        this.bondList[index].chargeMath = standItem.chargeMath;
        this.bondList[index].chargePrice = standItem.standardPrice;
        this.bondList[index].priceUnit = standItem.priceUnit;
        this.bondList[index].fixedAmount = standItem.fixedAmount;
      }
    },
    handleHouseOption: function handleHouseOption(list) {
      var _this2 = this;

      this.init();
      this.clauseList.forEach(function (item1, index) {
        var houseListOption = _this2.houseList.map(function (item2) {
          return {
            value: item2.resourceId,
            name: item2.resourceCode
          };
        });

        var leaseContractTeamsResourceVos = _this2.houseList.map(function (item2) {
          return item2.resourceId;
        });

        _this2.$set(_this2.clauseList[index], 'houseListOption', houseListOption);

        _this2.$set(_this2.clauseList[index], 'chargeBeginDate', _this2.baseInfo.beginDate);

        _this2.$set(_this2.clauseList[index], 'chargeEndDate', _this2.baseInfo.endDate);

        if (item1.leaseContractTeamsResourceVos) {
          var resourceIds = item1.leaseContractTeamsResourceVos.map(function (item) {
            if (item.resourceId) {
              return item.resourceId;
            } else {
              return item;
            }
          });
          var includeResourceIds = leaseContractTeamsResourceVos.filter(function (resourceId) {
            return resourceIds.includes(resourceId);
          });

          _this2.$set(_this2.clauseList[index], 'leaseContractTeamsResourceVos', includeResourceIds);
        } else {
          _this2.$set(_this2.clauseList[index], 'leaseContractTeamsResourceVos', leaseContractTeamsResourceVos);
        }
      });
    },
    handlePrev: function handlePrev() {
      if (this.isGeneratingBills) {
        this.$emit('gobackFirst');
      } else {
        this.$emit('handCancle', 'parkingLotContractBack');
      }
    },
    handleGeneratingBills: function handleGeneratingBills() {
      if (this.clauseList.length < 1) {
        this.$message.error('请添加租赁条款');
        return false;
      }

      for (var i = 0; i < this.clauseList.length; i++) {
        var beginTime = new Date(this.clauseList[i].chargeBeginDate).getTime();
        var endTime = new Date(this.clauseList[i].chargeEndDate).getTime();

        if (this.clauseList[i].leaseContractTeamsResourceVos.length < 1) {
          this.$message.error('请选择房间');
          return false;
        }

        if (!this.clauseList[i].costBearers) {
          this.$message.error('请选择费用承担人');
          return false;
        }

        if (!this.clauseList[i].chargeBeginDate) {
          this.$message.error('请选择收费起始日期');
          return false;
        }

        if (!this.clauseList[i].chargeEndDate) {
          this.$message.error('请选择收费结束日期');
          return false;
        }

        if (!this.clauseList[i].chargeStandardId) {
          this.$message.error('请选择收费标准');
          return false;
        }

        if (beginTime && (beginTime < new Date(this.baseInfo.beginDate).getTime() || beginTime > new Date(this.baseInfo.endDate).getTime())) {
          this.$message.error('收费起始日期应在合同日期范围内');
          return false;
        }

        if (endTime && (endTime < new Date(this.baseInfo.beginDate).getTime() || beginTime > new Date(this.baseInfo.endDate).getTime())) {
          this.$message.error('收费结束日期应在合同日期范围内');
          return false;
        }
      }

      for (var _i = 0; _i < this.bondList.length; _i++) {
        var _beginTime = new Date(this.clauseList[_i].chargeBeginDate).getTime();

        var _endTime = new Date(this.clauseList[_i].chargeEndDate).getTime();

        if (this.bondList[_i].leaseContractTeamsResourceVos.length < 1) {
          this.$message.error('请选择房间');
          return false;
        }

        if (!this.bondList[_i].costBearers) {
          this.$message.error('请选择费用承担人');
          return false;
        }

        if (!this.bondList[_i].chargeBeginDate) {
          this.$message.error('请选择收费起始日期');
          return false;
        }

        if (!this.bondList[_i].chargeEndDate) {
          this.$message.error('请选择收费结束日期');
          return false;
        }

        if (!this.bondList[_i].chargeStandardId) {
          this.$message.error('请选择收费标准');
          return false;
        }

        if (_beginTime && (_beginTime < new Date(this.baseInfo.beginDate).getTime() || _beginTime > new Date(this.baseInfo.endDate).getTime())) {
          this.$message.error('收费起始日期应在合同日期范围内');
          return false;
        }

        if (_endTime && (_endTime < new Date(this.baseInfo.beginDate).getTime() || _beginTime > new Date(this.baseInfo.endDate).getTime())) {
          this.$message.error('收费结束日期应在合同日期范围内');
          return false;
        }
      }

      if (this.isGeneratingBills) {
        this.$emit('jumpToThird', 'generate');
      } else {
        this.$emit('handCancle', 'houseContractGenerate');
      }

      return true;
    },
    handleAddClause: function handleAddClause() {
      var houseListOption = this.houseList.map(function (item2) {
        return {
          value: item2.resourceId,
          name: item2.resourceCode
        };
      });
      var leaseContractTeamsResourceVos = this.houseList.map(function (item2) {
        return item2.resourceId;
      });
      var chargeBeginDate = this.baseInfo.beginDate;
      var chargeEndDate = this.baseInfo.endDate;
      this.clauseList.push({
        houseListOption: houseListOption,
        leaseContractTeamsResourceVos: leaseContractTeamsResourceVos,
        chargeBeginDate: chargeBeginDate,
        chargeEndDate: chargeEndDate
      });
    },
    handleAddBond: function handleAddBond() {
      var houseListOption = this.houseList.map(function (item2) {
        return {
          value: item2.resourceId,
          name: item2.resourceCode
        };
      });
      var leaseContractTeamsResourceVos = this.houseList.map(function (item2) {
        return item2.resourceId;
      });
      this.bondList.push({
        houseListOption: houseListOption,
        leaseContractTeamsResourceVos: leaseContractTeamsResourceVos
      });
    },
    handleCheckbox: function handleCheckbox(val, index) {
      if (!val) {
        this.$set(this.bindList[index], 'newStandardId', '');
      }
    },
    handleClauseDelete: function handleClauseDelete(index) {
      this.clauseList.splice(index, 1);
    },
    handleBondDelete: function handleBondDelete(index) {
      this.bondList.splice(index, 1);
    },
    loadChargeOption: function loadChargeOption() {
      var _this3 = this;

      fetchChargeList({}).then(function (r) {
        _this3.chargeOption = r.data.data;
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle');
    },
    handleBeginDate: function handleBeginDate(time, index) {
      var beginTime = new Date(time).getTime();
      var endTime = new Date(this.clauseList[index].chargeEndDate).getTime();

      if (time && (beginTime < new Date(this.baseInfo.beginDate).getTime() || beginTime > new Date(this.baseInfo.endDate).getTime())) {
        this.$message({
          message: '收费起始日期应在合同日期范围内',
          type: 'warning'
        });
        this.$set(this.clauseList[index], 'chargeBeginDate', '');
        return;
      }

      if (time && this.clauseList[index].chargeEndDate) {
        if (beginTime > endTime) {
          this.$message({
            message: '收费起始日期不能晚于收费结束日期',
            type: 'warning'
          });
          this.$set(this.clauseList[index], 'chargeBeginDate', '');
        }
      }
    },
    handleBondBeginDate: function handleBondBeginDate(time, index) {
      var beginTime = new Date(time).getTime();
      var endTime = new Date(this.bondList[index].chargeEndDate).getTime();

      if (time && (beginTime < new Date(this.baseInfo.beginDate).getTime() || beginTime > new Date(this.baseInfo.endDate).getTime())) {
        this.$message({
          message: '收费起始日期应在合同日期范围内',
          type: 'warning'
        });
        this.$set(this.bondList[index], 'chargeBeginDate', '');
        return;
      }

      if (time && this.bondList[index].chargeEndDate) {
        if (beginTime > endTime) {
          this.$message({
            message: '收费起始日期不能晚于收费结束日期',
            type: 'warning'
          });
          this.$set(this.bondList[index], 'chargeBeginDate', '');
        }
      }
    },
    handleEndDate: function handleEndDate(time, index) {
      var beginTime = new Date(this.clauseList[index].chargeBeginDate).getTime();
      var endTime = new Date(time).getTime();

      if (time && (endTime < new Date(this.baseInfo.beginDate).getTime() || endTime > new Date(this.baseInfo.endDate).getTime())) {
        this.$message({
          message: '收费结束日期应在合同日期范围内',
          type: 'warning'
        });
        this.$set(this.clauseList[index], 'chargeEndDate', '');
        return;
      }

      if (time && this.clauseList[index].chargeBeginDate) {
        if (endTime < beginTime) {
          this.$message({
            message: '收费结束日期不能早于收费起始日期',
            type: 'warning'
          });
          this.$set(this.clauseList[index], 'chargeEndDate', '');
        }
      }
    },
    handleBondEndDate: function handleBondEndDate(time, index) {
      var beginTime = new Date(this.bondList[index].chargeBeginDate).getTime();
      var endTime = new Date(time).getTime();

      if (time && (endTime < new Date(this.baseInfo.beginDate).getTime() || endTime > new Date(this.baseInfo.endDate).getTime())) {
        this.$message({
          message: '收费结束日期应在合同日期范围内',
          type: 'warning'
        });
        this.$set(this.bondList[index], 'chargeEndDate', '');
        return;
      }

      if (time && this.bondList[index].chargeBeginDate) {
        if (endTime < beginTime) {
          this.$message({
            message: '收费结束日期不能早于收费起始日期',
            type: 'warning'
          });
          this.$set(this.bondList[index], 'chargeEndDate', '');
        }
      }
    }
  }
};